import React, { ComponentProps, useState, useEffect } from "react";
import {
  StreakStatus,
  StreakConfigList,
} from "@nestcoinco/hyper-api-gateway-api-client";

import "./StreakCount.scss";
import FlameIcon from "../../icons/FlameIcon";
import StreakModal from "../modals/StreakModal/StreakModal";
import { handleGetAvailableStreaks } from "../../../api-clients/streaksClient";

interface StreakCountProps extends ComponentProps<"button"> {
  streakStatus: StreakStatus;
}

function StreakCount({ streakStatus, ...restProps }: StreakCountProps) {
  const [isOpen, setIsOpen] = useState(false);
  const [streakConfig, setStreakConfig] = useState<StreakConfigList>();

  useEffect(() => {
    const getStreakConfig = async () => {
      const streakConfigList = await handleGetAvailableStreaks();
      setStreakConfig(streakConfigList);
    };

    getStreakConfig();
  }, []);

  return (
    <>
      <button
        className="streak-count"
        onClick={() => setIsOpen(true)}
        {...restProps}
      >
        <FlameIcon />
        <span>{streakStatus.streakCount}</span>
      </button>
      {isOpen && streakConfig && (
        <StreakModal
          days={streakStatus.streakCount}
          show={isOpen}
          onHide={() => setIsOpen(false)}
          status={streakStatus}
          config={streakConfig}
        />
      )}
    </>
  );
}

export default StreakCount;
